import { render, staticRenderFns } from "./MaxConcentration.vue?vue&type=template&id=004a6808&"
import script from "./MaxConcentration.vue?vue&type=script&lang=js&"
export * from "./MaxConcentration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports